import { IconMessages } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';
import { produce } from 'immer';

import { Bookmarks } from '#components/bookmarks/Bookmarks';
import { useChatSessionHistory } from '#hooks/useChatSessionHistory';

export const Route = createFileRoute('/ai')({
  component: RouteComponent,
  beforeLoad: () => ({
    getTitle: () => 'Atlas AI',
  }),
});

function RouteComponent() {
  const [chatSessionHistory, setChatSessionHistory] = useChatSessionHistory();

  return (
    <Bookmarks
      title="My Chats"
      bookmarks={Object.values(chatSessionHistory)
        .map((session) => ({
          ...session,
          id: session.id,
          title: session.title ?? `${session.messages?.at(0)?.completionMessage ?? 'Unnamed Chat'}`,
          icon: <IconMessages size={16} />,
          data: {},
        }))
        .toSorted(
          (a, b) =>
            new Date(a.updatedAt ?? a.createdAt ?? new Date()).getTime() -
            new Date(b?.updatedAt ?? b.createdAt ?? new Date()).getTime(),
        )}
      onDelete={(session) => {
        setChatSessionHistory((sessions) =>
          produce(sessions, (draft) => {
            delete draft[session.id];
          }),
        );
      }}
    />
  );
}
